import ArticleCategory from "./category";
import ArticleManagementList from "./list";
import "./styles.scss";
import React, { useState } from "react";

const ArticleManagement = () => {
  const [propertyTab, setPropertyTab] = useState("article-list");

  return (
    <>
      <div className="student_management">
        <div className="dashboard_title has_child">
          <h3>Article Management</h3>
        </div>
        <div className="wrapper_cstm_tabers" style={{ marginBottom: "20px" }}>
          <ul style={{ paddingLeft: "0px" }}>
            
            <li
              className={propertyTab === "article-list" ? "active" : ""}
              onClick={() => setPropertyTab("article-list")}
            >
              Article List
            </li>

            <li
              className={propertyTab === "article-category" ? "active" : ""}
              onClick={() => setPropertyTab("article-category")}
            >
              Article Category
            </li>

          </ul>
        </div>

        {propertyTab === "article-list" && <ArticleManagementList />}

        {propertyTab === "article-category" && <ArticleCategory />}
      </div>
    </>
  );
};

export default ArticleManagement;
